module.exports = __webpack_public_path__ + "img/1003.8b74ebe9.png";